(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sterntaler-size-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sizeGuides = document.querySelectorAll('.size-guide[data-size-guide-handle]');
    const categoryButtons = document.querySelectorAll('.size-guide-overview__category-button');
    const measurementInput = document.getElementById('measurement-filter-value');
    const ageInput = document.getElementById('age-filter-value');
    const ageUnitSelect = document.getElementById('age-filter-unit');
    const newbornCheckbox = document.getElementById('newborn-filter');
    const applyBtn = document.getElementById('filter-apply');
    const resetBtn = document.getElementById('filter-reset');
    const entryRows = document.querySelectorAll('.size-guide-table__entry-row');

    // Sortiere die Tabellenzeilen in jeder size-guide Tabelle
    function getSortValue(label) {
      // NEWBORN kommt ganz am Anfang
      if (label.toUpperCase() === 'NEWBORN') {
        return -1;
      }
      // Versuche numerischen Wert zu extrahieren (z.B. "50", "50/56", "62")
      const match = label.match(/^(\d+)/);
      if (match) {
        return parseInt(match[1], 10);
      }
      // Fallback: alphabetisch ganz am Ende
      return 999999;
    }

    function sortTableRows() {
      sizeGuides.forEach(function(guide) {
        const tbody = guide.querySelector('.size-guide-table tbody');
        if (!tbody) return;

        const rows = Array.from(tbody.querySelectorAll('.size-guide-table__entry-row'));
        
        rows.sort(function(a, b) {
          // Primär: nach Alter (age_from_months)
          const ageA = parseFloat(a.getAttribute('data-age-from-months')) || 0;
          const ageB = parseFloat(b.getAttribute('data-age-from-months')) || 0;
          
          if (ageA !== ageB) {
            return ageA - ageB;
          }
          
          // Sekundär: nach size_label
          const labelA = a.getAttribute('data-size-label') || '';
          const labelB = b.getAttribute('data-size-label') || '';
          const sortA = getSortValue(labelA);
          const sortB = getSortValue(labelB);
          
          return sortA - sortB;
        });

        // Zeilen neu einfügen in sortierter Reihenfolge
        rows.forEach(function(row) {
          tbody.appendChild(row);
        });
      });
    }

    // Sortierung beim Laden ausführen
    sortTableRows();

    // Kategorie-Buttons Multi-Select
    function updateCategoryVisibility() {
      const activeHandles = Array.from(categoryButtons)
        .filter(btn => btn.classList.contains('active'))
        .map(btn => btn.getAttribute('data-category-handle'));
      
      sizeGuides.forEach(function(guide) {
        const guideHandle = guide.getAttribute('data-size-guide-handle');
        if (activeHandles.length === 0 || activeHandles.includes(guideHandle)) {
          guide.classList.remove('hidden');
        } else {
          guide.classList.add('hidden');
        }
      });
    }

    categoryButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const allActive = Array.from(categoryButtons).every(btn => btn.classList.contains('active'));
        
        if (allActive) {
          // Wenn alle aktiv: alle deaktivieren, nur geklickten aktivieren
          categoryButtons.forEach(btn => btn.classList.remove('active'));
          this.classList.add('active');
        } else {
          // Normales Toggle-Verhalten
          this.classList.toggle('active');
          
          // Prüfen ob jetzt alle inaktiv sind
          const noneActive = Array.from(categoryButtons).every(btn => !btn.classList.contains('active'));
          if (noneActive) {
            // Alle wieder aktivieren
            categoryButtons.forEach(btn => btn.classList.add('active'));
          }
        }
        
        updateCategoryVisibility();
      });
    });

    // Konvertiert Alter in Monate (24 Monate = 2 Jahre = 24 Monate)
    function convertToMonths(value, unit) {
      if (unit === 'Jahre') {
        return value * 12;
      }
      return value;
    }

    function applyFilters() {
      const measurementValue = parseFloat(measurementInput.value);
      const ageValue = parseFloat(ageInput.value);
      const ageUnit = ageUnitSelect.value;
      const isNewbornChecked = newbornCheckbox && newbornCheckbox.checked;

      const hasMeasurement = !isNaN(measurementValue) && measurementValue > 0;
      const hasAge = !isNaN(ageValue) && ageValue >= 0;

      if (!hasMeasurement && !hasAge && !isNewbornChecked) {
        return;
      }

      // Alter immer in Monate konvertieren für einheitlichen Vergleich
      const ageInMonths = hasAge ? convertToMonths(ageValue, ageUnit) : null;

      sizeGuides.forEach(function(guide) {
        if (guide.classList.contains('hidden')) {
          return;
        }

        const rows = guide.querySelectorAll('.size-guide-table__entry-row');
        
        const rowsArray = Array.from(rows);
        const matchingIndices = [];

        // Zuerst alle Treffer identifizieren
        rowsArray.forEach(function(row, index) {
          row.classList.remove('hidden', 'highlighted', 'neighbor');

          let matchesMeasurement = false;
          let matchesAge = false;
          let matchesNewborn = false;

          // Neugeborene-Filter: prüft auf age_unit="new_born" ODER size_label="NEWBORN"
          if (isNewbornChecked) {
            const rowAgeUnit = row.getAttribute('data-age-unit');
            const rowSizeLabel = (row.getAttribute('data-size-label') || '').toUpperCase();
            matchesNewborn = rowAgeUnit === 'new_born' || rowSizeLabel === 'NEWBORN';
          }

          if (hasMeasurement) {
            const lengthFromRaw = row.getAttribute('data-length-from') || '';
            const lengthToRaw = row.getAttribute('data-length-to') || '';
            const lengthFrom = parseFloat(lengthFromRaw.replace(',', '.'));
            const lengthTo = parseFloat(lengthToRaw.replace(',', '.'));
            
            // Bei from=0 gilt "bis to"
            const effectiveLengthFrom = (isNaN(lengthFrom) || lengthFrom === 0) ? 0 : lengthFrom;
            
            if (!isNaN(lengthTo)) {
              matchesMeasurement = measurementValue >= effectiveLengthFrom && measurementValue <= lengthTo;
            }
          }

          if (hasAge && !isNewbornChecked) {
            // Alter ist bereits in Monaten im data-Attribut gespeichert
            const rowAgeFromMonths = parseFloat(row.getAttribute('data-age-from-months'));
            const rowAgeToMonths = parseFloat(row.getAttribute('data-age-to-months'));

            if (!isNaN(rowAgeFromMonths) && !isNaN(rowAgeToMonths)) {
              // Bei from=0 gilt "bis to"
              const effectiveAgeFrom = rowAgeFromMonths === 0 ? 0 : rowAgeFromMonths;
              matchesAge = ageInMonths >= effectiveAgeFrom && ageInMonths <= rowAgeToMonths;
            }
          }

          // Treffer merken
          const isMatch = (isNewbornChecked && matchesNewborn) ||
                          (hasMeasurement && matchesMeasurement) ||
                          (!hasMeasurement && hasAge && matchesAge);
          
          if (isMatch) {
            matchingIndices.push(index);
          }
        });

        // Indices für sichtbare Zeilen ermitteln (Treffer + Vorgänger + Nachfolger)
        const visibleIndices = new Set();
        matchingIndices.forEach(function(index) {
          if (index > 0) visibleIndices.add(index - 1);  // Vorgänger
          visibleIndices.add(index);                      // Treffer
          if (index < rowsArray.length - 1) visibleIndices.add(index + 1);  // Nachfolger
        });

        // Wenn keine Treffer, gesamten size_guide ausblenden
        if (matchingIndices.length === 0) {
          guide.classList.add('no-results');
          return;
        }
        
        guide.classList.remove('no-results');

        // Klassen anwenden
        rowsArray.forEach(function(row, index) {
          if (matchingIndices.includes(index)) {
            row.classList.add('highlighted');
          } else if (visibleIndices.has(index)) {
            row.classList.add('neighbor');
          } else {
            row.classList.add('hidden');
          }
        });
      });
    }

    function resetFilters() {
      measurementInput.value = '';
      ageInput.value = '';
      if (newbornCheckbox) {
        newbornCheckbox.checked = false;
      }
      // Alle Kategorie-Buttons aktivieren
      categoryButtons.forEach(function(button) {
        button.classList.add('active');
      });
      sizeGuides.forEach(function(guide) {
        guide.classList.remove('no-results', 'hidden');
      });
      entryRows.forEach(function(row) {
        row.classList.remove('hidden', 'highlighted', 'neighbor');
      });
    }

    if (applyBtn) {
      applyBtn.addEventListener('click', applyFilters);
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', resetFilters);
    }

    if (measurementInput) {
      measurementInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          applyFilters();
        }
      });
    }

    if (ageInput) {
      ageInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          applyFilters();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
